import moment from 'moment';

import {
  ComplexDateOutputValue,
  DiscreteDateLabels,
  DiscreteValue,
} from './types';

const DATE_FORMAT = 'YYYY-MM-DD';

const formatDateForDisplay = (dateString: string) => {
  if (!dateString) return '';
  const parsed = moment(dateString, DATE_FORMAT);
  return parsed.isValid() ? parsed.format('L') : '';
};

const formatDiscreteLabel = (
  discrete: DiscreteValue,
  labels: DiscreteDateLabels,
) => {
  const { direction, granularity, amount = 1 } = discrete;
  if (direction === 'this') return labels.granularitiesThis[granularity];
  return `${labels.directions[direction]} ${amount} ${labels.granularities[granularity]}`;
};

export const formatDisplayValue = (
  value: ComplexDateOutputValue | null,
  labels: DiscreteDateLabels,
) => {
  if (!value) return '';
  if (value.type === 'discrete') return formatDiscreteLabel(value, labels);
  if (value.type === 'single') return formatDateForDisplay(value.date);

  const start = formatDateForDisplay(value.dateFrom);
  const end = formatDateForDisplay(value.dateTo);
  if (start === end) return start;
  return `${start} - ${end}`;
};
